import React from 'react';
import classNames from 'clsx';
import type { SkinScreenWidthContainerWrapperProps } from '../SkinScreenWidthContainer';

const WrapperElement: React.FC<
  SkinScreenWidthContainerWrapperProps & {
    skinStyles: Record<string, string>;
  }
> = ({
  id,
  className,
  skinClassName,
  tagName = 'div',
  transition,
  transitionEnded,
  eventHandlers,
  skinStyles,
  children,
  tabIndex,
  lang,
}) => {
  const SemanticElement = tagName as keyof JSX.IntrinsicElements;

  return (
    <SemanticElement
      id={id}
      className={classNames(
        skinClassName,
        transition && skinStyles[transition],
        transitionEnded && skinStyles.transitionEnded,
        className,
      )}
      tabIndex={tabIndex}
      lang={lang}
      {...eventHandlers}
    >
      {children}
    </SemanticElement>
  );
};

export default WrapperElement;
